<template>
  <div class="notice-tip" :class="{close: !showContent}">
    <span class="el-icon-close close-popup" @click="closePopup"></span>
    <div class="notice-box">
      <div class="notice-content" v-for="(item, index) in messageData" :key="item.id"
        v-show="(index + 1) == currentPage">
        <h3 style="font-size: 16px" class="text-center">
          {{ item.title }}
        </h3>
        <!-- eslint-disable -->
        <div :title="$translate('goToSee')" @click="goToView(item)" class="notice-html pointer"
          v-html="$xss.process(item.content)"></div>
      </div>
      <div class="pageNav text-center">
        <span @click="prevData" class="el-icon-arrow-left"
          :class="{active: currentPage == 1, pointer: currentPage !== 1}"></span>
        <span> <span>{{ currentPage }}</span> / <span>{{ total }}</span> </span>
        <span @click="nextData"
          :class="{active: currentPage == messageData.length, pointer: currentPage !== messageData.length}"
          class="el-icon-arrow-right"></span>
      </div>
      <div class="flex flex_center">
        <p class="notice-isRead" @click="readAll"
          v-if="messageData[currentPage - 1] && messageData[currentPage - 1].type !== 'userInfo'">
          {{ $translate('allRead') }}
        </p>
        <p class="notice-isRead">
          <el-checkbox v-model="checked" @change="notTips">
            {{ $translate('notPrompt') }}
          </el-checkbox>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["messageData"],
  data() {
    return {
      currentData: {},
      currentPage: 0,
      showContent: true,
      clickDisabled: true,
      checked: false,
    };
  },
  computed: {
    total() {
      return this.messageData.length || 0;
    },
  },
  mounted() {
    if (this.messageData.length) {
      this.currentPage = 1;
    }
  },
  methods: {
    goToView(item) {
      if (item.type == "userInfo") {
        this.$router.push({ name: "systemmsg" });
      } else {
        this.$router.push({ name: "announcement" });
      }
    },
    closePopup() {
      this.showContent = !this.showContent;
    },
    notTips(val) {
      //  不再提示
      if (val) {
        // 如果不再提示就记录到浏览器端，下次再有消息提示就不再弹框出来
        localStorage["_EBINOTIPSMESSAGE"] = "VFJVRQ==";
      } else {
        localStorage.removeItem("_EBINOTIPSMESSAGE");
      }
    },
    nextData() {
      if (this.currentPage == this.messageData.length) {
        return;
      }
      this.currentPage += 1;
    },
    prevData() {
      if (this.currentPage == 1) {
        return;
      }
      this.currentPage -= 1;
    },
    readAll() {
      let query = "";

      const ids = this.messageData.map((item) => item.id);

      for (let index = 0; index < ids.length; index++) {
        if (index == 0) {
          query += "?";
        }
        query += "ids=" + ids[index];
        if (index !== ids.length - 1) {
          query += "&";
        }
      }
      if (!query) return;
      this.$api.Announcement.UpdateAnnouncementReadAll(query).then((res) => {
        if (res && res.isSuccess) {
          this.closePopup();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.notice-tip {
  width: 360px;
  padding: 14px;
  border-radius: 8px;
  box-sizing: border-box;
  border: 1px solid #ebeef5;
  position: fixed;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
  bottom: 16px;
  right: 0;
  z-index: 2000;
  transition: all 3s;
  &.close {
    opacity: 0;
    right: -1000px;
  }
  .close-popup {
    position: absolute;
    right: 16px;
    top: 16px;
    font-size: 16px;
    cursor: pointer;
  }
}
.notice-box {
  width: 100%;
  padding: 10px;
  .notice-content {
    .notice-html {
      margin-top: 2em;
      margin-bottom: 2em;
      max-height: 100%;
      overflow: auto;
    }
  }
  .pageNav {
    span {
      margin: 10px;
    }
    span.active {
      color: #ccc;
    }
  }
  .notice-isRead {
    text-align: right;
    color: #6078f8;
    cursor: pointer;
  }
}
</style>
